module.exports = __webpack_public_path__ + "img/popularize-icon2-03.064c2ef4.png";